import React from 'react';
import { HeartPulseIcon, ShieldCheckIcon, ShieldPlusIcon, ArrowRightIcon } from 'lucide-react';
import { LinkButton } from './Button';
import type { Service } from '../../data/services';
const icons = {
  life: ShieldCheckIcon,
  health: HeartPulseIcon,
  supplemental: ShieldPlusIcon
};
export function ServiceCard({
  service
}: {
  service: Service;
}) {
  const Icon = icons[service.icon];
  return <article className="group flex h-full flex-col rounded-[24px] border border-navy/[0.08] bg-white p-8 shadow-soft transition-[transform,box-shadow,border-color] duration-300 ease-out hover:-translate-y-1 hover:border-teal/25 hover:shadow-lift lg:p-9" data-id="element-305" data-mp="10234llgct1z7">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-sage/15 text-teal transition-colors duration-300 ease-out group-hover:bg-sage/25" data-id="element-306" data-mp="q9nqx0c3azk4">
        <Icon size={24} strokeWidth={1.25} data-id="element-307" data-mp="h9qw0gz3x4gm" />
      </span>
      <h3 className="mt-7 font-display text-[15px] font-semibold tracking-[0.1em] text-navy" data-id="element-308" data-mp="cc8w1g32hzkr">
        {service.title}
      </h3>
      <p className="mt-4 text-[14px] font-light leading-relaxed text-ink/65" data-id="element-309" data-mp="776apbxzhj0q">
        {service.description}
      </p>
      <ul className="mt-6 flex-1 space-y-2.5 border-t border-navy/[0.07] pt-6" data-id="element-310" data-mp="bzqz1xy4f3wv">
        {service.features.map(f => <li key={f} className="flex items-start gap-3 text-[13.5px] font-light text-ink/70" data-id="element-311" data-mp="3uau9ed8p5ggm">
            <span aria-hidden="true" className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-gold" data-id="element-312" data-mp="36vwxd3y9obb" />
            {f}
          </li>)}
      </ul>
      <LinkButton href="#agenda" variant="secondary" className="mt-8 w-full" aria-label={`${service.cta} sobre ${service.title.toLowerCase()}`} data-id="element-313" data-mp="uybmng0szr5r">
        {service.cta}
        <ArrowRightIcon size={15} className="transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-314" data-mp="lwc6sr1iyt4e" />
      </LinkButton>
    </article>;
}